import './legal-page.css'

import React, {FC, ReactNode, useEffect} from 'react'
import {Link} from 'react-router-dom'

import {LegalFooter} from '../../components/legal/legal-footer'
import {LEGAL} from '../../legal/legal-content'
import {LEGAL_KINDS, legalFooter, LegalKind, LegalLang, legalPath} from '../../legal/legal-helpers'
import {renderReact} from '../../legal/legal-render'

const RouterLink: FC<{href: string; children?: ReactNode}> = ({href, children}) => <Link to={href}>{children}</Link>

type LegalPageProps = {
  kind: LegalKind
  lang: LegalLang
}

/** Public privacy / terms / data-deletion page. No login, no venue: it renders the kit document as it is. */
export const LegalPage: FC<LegalPageProps> = ({kind, lang}) => {
  const doc = LEGAL.content[lang][kind]
  const footer = legalFooter(lang)

  useEffect(() => {
    const previousTitle = document.title
    const previousLang = document.documentElement.lang
    document.title = `${doc.title} | ${LEGAL.brand}`
    document.documentElement.lang = lang
    return () => {
      document.title = previousTitle
      document.documentElement.lang = previousLang
    }
  }, [doc.title, lang])

  return (
    <div className='legal-page'>
      <header className='legal-page__header'>
        <Link
          to='/'
          className='legal-page__brand'
        >
          {LEGAL.brand}
        </Link>
        <nav
          className='legal-page__nav'
          aria-label='Legal'
        >
          {LEGAL_KINDS.map((item) => (
            <Link
              key={item}
              to={legalPath(item, lang)}
              aria-current={item === kind ? 'page' : undefined}
            >
              {footer[item]}
            </Link>
          ))}
        </nav>
        <nav
          className='legal-page__lang'
          aria-label='Language'
        >
          <Link
            to={legalPath(kind, 'en')}
            hrefLang='en'
            aria-current={lang === 'en' ? 'true' : undefined}
          >
            EN
          </Link>
          <span aria-hidden='true'>|</span>
          <Link
            to={legalPath(kind, 'th')}
            hrefLang='th'
            aria-current={lang === 'th' ? 'true' : undefined}
          >
            ไทย
          </Link>
        </nav>
      </header>
      <main
        className='legal-page__card'
        lang={lang}
      >
        {renderReact(React, doc, {linkComponent: RouterLink})}
      </main>
      <p
        className='legal-page__entity'
        lang={lang}
      >
        {footer.copyright}
      </p>
      <LegalFooter
        lang={lang}
        compact
        sameTab
      />
    </div>
  )
}
